(function(){
  if(window.__bledTrustV1)return;window.__bledTrustV1=true;
  function addBusinessDays(source,days){
    var d=new Date(source.getFullYear(),source.getMonth(),source.getDate()),n=0;
    while(n<days){d.setDate(d.getDate()+1);var day=d.getDay();if(day!==0&&day!==6)n++}
    return d;
  }
  function fmt(d){
    try{return new Intl.DateTimeFormat(document.documentElement.lang||'fr-FR',{day:'numeric',month:'short'}).format(d).replace('.','')}
    catch(e){return d.getDate()+'/'+(d.getMonth()+1)}
  }
  function render(){
    var now=new Date(),min=addBusinessDays(now,5),max=addBusinessDays(now,8);
    var label=fmt(min)+' – '+fmt(max);
    document.querySelectorAll('[data-bled-trust-window]').forEach(function(el){el.textContent=label});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',render);else render();
  document.addEventListener('cart:open',render);
  document.addEventListener('cart:updated',render);
})();

/* Bled Eleven — quick buy + real cart state / 19-09-2026 */
(function(){
  function parseVariants(root){
    var node=root.querySelector('[data-b11-qb-variants]');
    if(!node)return[];
    try{return JSON.parse(node.textContent||'[]')}catch(e){return[]}
  }
  function getOption(variant,index){
    if(Array.isArray(variant.options))return variant.options[index];
    return variant['option'+(index+1)];
  }
  function setBusy(root,busy){
    root.classList.toggle('is-busy',busy);
    root.setAttribute('aria-busy',busy?'true':'false');
  }
  function cartAddRoute(){
    return (window.theme&&window.theme.routes&&window.theme.routes.cartAdd)||'/cart/add.js';
  }
  function cartPageRoute(){
    return (window.theme&&window.theme.routes&&window.theme.routes.cartPage)||'/cart';
  }
  function cartJsonRoute(){
    return (window.theme&&window.theme.routes&&window.theme.routes.cart)||'/cart.js';
  }
  function nativeFallback(form){
    try{
      form.action=cartAddRoute().replace(/\.js(?:\?.*)?$/,'');
      form.method='post';
      HTMLFormElement.prototype.submit.call(form);
    }catch(e){
      window.location.href=cartPageRoute();
    }
  }
  function refreshCartState(){
    return fetch(cartJsonRoute(),{credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
      .then(function(cart){
        document.querySelectorAll('.cart-link__bubble').forEach(function(el){
          el.classList.toggle('cart-link__bubble--visible',cart.item_count>0);
        });
        document.querySelectorAll('[data-b11-cart-count]').forEach(function(el){
          el.textContent=String(cart.item_count||0);
          el.toggleAttribute('data-empty',!cart.item_count);
        });
        return cart;
      });
  }
  function emitAdded(root,size,cart){
    document.dispatchEvent(new CustomEvent('b11:cart-added',{detail:{
      productId:root.getAttribute('data-b11-product-id')||'',
      title:root.getAttribute('data-b11-product-title')||'Produit',
      url:root.getAttribute('data-b11-product-url')||cartPageRoute(),
      image:root.getAttribute('data-b11-product-image')||'',
      price:root.getAttribute('data-b11-product-price')||'',
      size:size||'',
      count:cart&&cart.item_count?cart.item_count:0,
      cart:cart||null
    }}));
  }
  function init(root){
    if(root.dataset.b11Ready==='1')return;
    root.dataset.b11Ready='1';
    var variants=parseVariants(root);
    var input=root.querySelector('[data-b11-qb-id]');
    var sizeIndex=parseInt(root.getAttribute('data-b11-size-index')||'-1',10);
    var sizeButtons=[].slice.call(root.querySelectorAll('[data-b11-qb-size]'));
    var sizeLabel=root.querySelector('[data-b11-qb-size-label]');
    var status=root.querySelector('[data-b11-qb-status]');
    var addButton=root.querySelector('[data-b11-qb-add]');
    var form=root.querySelector('[data-b11-qb-form]');
    if(!form||!input)return;

    if(sizeIndex>=0){
      sizeButtons.forEach(function(btn){
        var value=btn.getAttribute('data-value');
        var available=variants.some(function(v){
          return v.available&&String(getOption(v,sizeIndex))===String(value);
        });
        btn.disabled=!available;
        btn.setAttribute('aria-disabled',available?'false':'true');
      });
    }

    function selectSize(value){
      var match=variants.find(function(v){
        return v.available&&(sizeIndex<0||String(getOption(v,sizeIndex))===String(value));
      });
      if(!match)return;
      input.value=String(match.id);
      try{
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }catch(e){}
      sizeButtons.forEach(function(btn){
        var active=btn.getAttribute('data-value')===String(value);
        btn.classList.toggle('is-selected',active);
        btn.setAttribute('aria-pressed',active?'true':'false');
      });
      if(sizeLabel)sizeLabel.textContent=value;
      if(addButton)addButton.disabled=false;
    }

    sizeButtons.forEach(function(btn){
      btn.addEventListener('click',function(){selectSize(btn.getAttribute('data-value'))});
    });

    var current=variants.find(function(v){return String(v.id)===String(input.value)});
    if(current&&sizeIndex>=0)selectSize(getOption(current,sizeIndex));

    function addItem(){
      if(!input.value)return;
      setBusy(root,true);
      if(status)status.textContent='AJOUT EN COURS…';
      var body=new URLSearchParams();
      body.append('id',String(input.value));
      body.append('quantity','1');

      fetch(cartAddRoute(),{
        method:'POST',
        credentials:'same-origin',
        headers:{
          'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8',
          'Accept':'application/json'
        },
        body:body.toString()
      })
      .then(function(response){
        if(!response.ok){
          return response.text().then(function(t){throw new Error(t||'Cart add failed')});
        }
        return response.json();
      })
      .then(function(){
        return refreshCartState().catch(function(){return null});
      })
      .then(function(cart){
        var selected=sizeLabel?sizeLabel.textContent:'';
        if(status)status.textContent='AJOUTÉ AU PANIER ✓';
        if(addButton){
          addButton.dataset.b11OldText=addButton.dataset.b11OldText||addButton.textContent;
          addButton.textContent='AJOUTÉ ✓';
          setTimeout(function(){
            addButton.textContent=addButton.dataset.b11OldText||'AJOUTER AU PANIER';
          },1800);
        }
        emitAdded(root,selected,cart);
        setBusy(root,false);
      })
      .catch(function(){
        if(status)status.textContent='AJOUT DIRECT…';
        setBusy(root,false);
        nativeFallback(form);
      });
    }

    if(addButton){
      addButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        addItem();
      });
    }
  }

  function boot(){
    document.querySelectorAll('[data-b11-qb]').forEach(init);
    document.querySelectorAll('.b11v7-shop__rail,.b11v7-radar__rail,.b11v9-country-panel__track').forEach(function(rail){
      rail.setAttribute('role','region');
      if(!rail.getAttribute('aria-label'))rail.setAttribute('aria-label','Produits à faire défiler horizontalement');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();

/* Bled Eleven — V6 WHITE LIGHT / stable mobile interaction */
(function(){
  if(window.__B11WhiteLightV6)return;
  window.__B11WhiteLightV6=true;
  var mobile=window.matchMedia('(max-width: 749px)');

  function countTshirts(cart){
    if(!cart||!Array.isArray(cart.items))return 0;
    return cart.items.reduce(function(total,item){
      var title=String(item.product_title||item.title||'').toLowerCase();
      if(title.indexOf('t-shirt')>-1||title.indexOf('tshirt')>-1||title.indexOf('tee-shirt')>-1){
        return total+(Number(item.quantity)||0);
      }
      return total;
    },0);
  }

  function initToast(){
    var toast=document.querySelector('[data-b11-cart-toast]');
    if(!toast||toast.dataset.b11Ready==='1')return;
    toast.dataset.b11Ready='1';
    var title=toast.querySelector('[data-b11-toast-title]');
    var meta=toast.querySelector('[data-b11-toast-meta]');
    var offer=toast.querySelector('[data-b11-toast-offer]');
    var media=toast.querySelector('[data-b11-toast-media]');
    var close=toast.querySelector('[data-b11-toast-close]');
    var timer;
    function hide(){
      toast.classList.remove('is-visible');
      clearTimeout(timer);
      setTimeout(function(){toast.hidden=true},180);
    }
    if(close)close.addEventListener('click',hide);
    document.addEventListener('b11:cart-added',function(e){
      var d=e.detail||{};
      if(title)title.textContent=d.title||'Produit ajouté';
      if(meta){
        var parts=[];
        if(d.size)parts.push('Taille '+d.size);
        if(d.price)parts.push(d.price);
        meta.textContent=parts.join(' · ');
      }
      if(offer){
        var shirts=countTshirts(d.cart);
        offer.textContent=shirts===1?'Encore 1 T-shirt pour profiter de -10 %':(shirts>=2?'Offre Duo atteinte ✓':'');
      }
      if(media){
        media.innerHTML='';
        if(d.image){
          var img=document.createElement('img');
          img.src=d.image;img.alt='';img.loading='eager';media.appendChild(img);
        }else media.textContent='B11';
      }
      toast.hidden=false;
      requestAnimationFrame(function(){toast.classList.add('is-visible')});
      clearTimeout(timer);
      timer=setTimeout(hide,4800);
    });
  }

  function initDock(){
    var dock=document.querySelector('[data-b11-mobile-dock]');
    if(!dock||dock.dataset.b11Ready==='1')return;
    dock.dataset.b11Ready='1';
    var hero=document.querySelector('.b11v7-hero');
    var footer=(document.querySelector('.site-footer')||document.querySelector('footer'));
    var links=[].slice.call(dock.querySelectorAll('[data-b11-dock-link]'));
    var targets=links.map(function(link){
      return document.getElementById(link.getAttribute('data-b11-dock-link'));
    }).filter(Boolean);

    function update(){
      if(!mobile.matches){dock.classList.remove('is-visible');return}
      var threshold=hero?Math.max(120,hero.offsetHeight*.55):220;
      var show=window.scrollY>threshold;
      if(footer&&footer.getBoundingClientRect().top<window.innerHeight-40)show=false;
      dock.classList.toggle('is-visible',show);
    }
    var ticking=false;
    window.addEventListener('scroll',function(){
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(function(){update();ticking=false});
    },{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();

    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        var visible=entries.filter(function(x){return x.isIntersecting})
          .sort(function(a,b){return b.intersectionRatio-a.intersectionRatio})[0];
        if(!visible)return;
        links.forEach(function(link){
          link.classList.toggle('is-active',link.getAttribute('data-b11-dock-link')===visible.target.id);
        });
      },{rootMargin:'-28% 0px -56% 0px',threshold:[0,.12,.35]});
      targets.forEach(function(target){io.observe(target)});
    }
    document.addEventListener('focusin',function(e){
      if(/INPUT|TEXTAREA|SELECT/.test(e.target.tagName))dock.classList.add('is-keyboard-hidden');
    });
    document.addEventListener('focusout',function(){dock.classList.remove('is-keyboard-hidden')});
  }

  function initRailMeters(){
    if(!mobile.matches)return;
    document.querySelectorAll('.b11v7-shop__rail,.b11v7-radar__rail,.b11v9-country-panel__track,.b11v7-social__rail').forEach(function(rail){
      if(rail.dataset.b11Meter==='1')return;
      rail.dataset.b11Meter='1';
      var meter=document.createElement('div');
      meter.className='b11-rail-meter';
      meter.setAttribute('aria-hidden','true');
      meter.innerHTML='<i></i>';
      rail.insertAdjacentElement('afterend',meter);
      var fill=meter.querySelector('i');
      function update(){
        var max=rail.scrollWidth-rail.clientWidth;
        var p=max>0?Math.max(0,Math.min(1,rail.scrollLeft/max)):1;
        fill.style.transform='scaleX('+p+')';
      }
      rail.addEventListener('scroll',update,{passive:true});
      window.addEventListener('resize',update,{passive:true});
      update();
    });
  }

  function initPdpSticky(){
    var bar=document.querySelector('[data-b11-pdp-sticky]');
    if(!bar||bar.dataset.b11Ready==='1')return;
    bar.dataset.b11Ready='1';
    var section=document.querySelector('.product-section');
    var mainAdd=document.querySelector('.product-single__form [data-add-to-cart]');
    var payWrap=document.querySelector('.product-single__form .shopify-payment-button');
    var add=bar.querySelector('[data-b11-pdp-add]');
    var pay=bar.querySelector('[data-b11-pdp-pay]');
    var price=bar.querySelector('[data-b11-pdp-price]');
    var size=bar.querySelector('[data-b11-pdp-size]');
    var footer=(document.querySelector('.site-footer')||document.querySelector('footer'));
    if(!section||!mainAdd)return;

    function selectedSize(){
      var checked=[].slice.call(section.querySelectorAll('[data-variant-input]:checked'));
      var input=checked.find(function(el){
        var name=String(el.name||'').toLowerCase();
        return name.indexOf('taille')>-1||name.indexOf('size')>-1;
      });
      return input?input.value:'';
    }
    function sync(){
      var mainPrice=section.querySelector('[data-product-price]');
      if(price&&mainPrice)price.textContent=(mainPrice.textContent||'').trim();
      var s=selectedSize();
      if(size)size.textContent=s?' · Taille '+s:'';
      if(add){add.disabled=!!mainAdd.disabled;add.textContent=mainAdd.disabled?'INDISPONIBLE':'AJOUTER'}
    }
    function update(){
      if(!mobile.matches){bar.hidden=true;bar.classList.remove('is-visible');return}
      var rect=mainAdd.getBoundingClientRect();
      var show=window.scrollY>180&&(rect.bottom<0||rect.top>window.innerHeight);
      if(footer&&footer.getBoundingClientRect().top<window.innerHeight-20)show=false;
      bar.hidden=!show;
      requestAnimationFrame(function(){bar.classList.toggle('is-visible',show)});
    }
    section.addEventListener('change',function(){setTimeout(sync,30)});
    if(add)add.addEventListener('click',function(){if(!mainAdd.disabled)mainAdd.click()});
    if(pay)pay.addEventListener('click',function(){
      var nativeBtn=document.querySelector('.product-single__form .shopify-payment-button__button');
      if(nativeBtn&&nativeBtn.offsetParent!==null){nativeBtn.click();return}
      (payWrap||mainAdd).scrollIntoView({behavior:'smooth',block:'center'});
    });
    var tick=false;
    window.addEventListener('scroll',function(){
      if(tick)return;tick=true;
      requestAnimationFrame(function(){update();tick=false});
    },{passive:true});
    window.addEventListener('resize',update,{passive:true});
    sync();update();
  }

  function initSmartUgc(){
    if(!('IntersectionObserver' in window))return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    if(navigator.connection&&navigator.connection.saveData)return;
    document.querySelectorAll('[data-video-card] video').forEach(function(video){
      if(video.dataset.b11Observer==='1')return;
      video.dataset.b11Observer='1';
      video.muted=true;
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting&&entry.intersectionRatio>.76){
            var p=video.play();if(p&&p.catch)p.catch(function(){});
          }else video.pause();
        });
      },{threshold:[0,.76,1]});
      io.observe(video);
    });
  }

  function initLightField(){
    var field=document.querySelector('[data-b11-light-field]');
    if(!field||!mobile.matches||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

    var hero=document.querySelector('.b11v7-hero');
    var activeCard=null;
    var x=-200,y=-200,pending=false,hideTimer=0;

    function updateCard(cx,cy){
      var el=document.elementFromPoint(cx,cy);
      var card=el&&el.closest?el.closest('.b11v7-shop__card,.b11v7-radar__card,.b11v9-country-card,.bled-carousel__card'):null;
      if(activeCard&&activeCard!==card)activeCard.classList.remove('is-b11-lighted');
      activeCard=card;
      if(card)card.classList.add('is-b11-lighted');
    }

    function paint(){
      pending=false;
      field.style.setProperty('--b11-light-x',x+'px');
      field.style.setProperty('--b11-light-y',y+'px');
      field.classList.add('is-active');

      if(hero){
        var r=hero.getBoundingClientRect();
        if(x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom){
          var hx=Math.max(0,Math.min(100,((x-r.left)/r.width)*100));
          var hy=Math.max(0,Math.min(100,((y-r.top)/r.height)*100));
          hero.style.setProperty('--b11-hero-light-x',hx+'%');
          hero.style.setProperty('--b11-hero-light-y',hy+'%');
          hero.classList.add('is-b11-hero-lit');
        }
      }
      updateCard(x,y);
    }

    function move(cx,cy){
      x=cx;y=cy;
      if(!pending){pending=true;requestAnimationFrame(paint)}
      clearTimeout(hideTimer);
    }

    function end(){
      clearTimeout(hideTimer);
      hideTimer=setTimeout(function(){
        field.classList.remove('is-active');
        if(hero)hero.classList.remove('is-b11-hero-lit');
        if(activeCard){activeCard.classList.remove('is-b11-lighted');activeCard=null}
      },180);
    }

    document.addEventListener('touchstart',function(e){
      if(e.touches&&e.touches[0])move(e.touches[0].clientX,e.touches[0].clientY);
    },{passive:true});
    document.addEventListener('touchmove',function(e){
      if(e.touches&&e.touches[0])move(e.touches[0].clientX,e.touches[0].clientY);
    },{passive:true});
    document.addEventListener('touchend',end,{passive:true});
    document.addEventListener('touchcancel',end,{passive:true});
  }

  function boot(){
    initToast();
    initDock();
    initRailMeters();
    initPdpSticky();
    initSmartUgc();
    initLightField();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);
  else boot();
  document.addEventListener('shopify:section:load',boot);
})();